import wixWindow from 'wix-window';

$w.onReady(function () {
    let formFactor = wixWindow.formFactor;

    if (formFactor === "Mobile") {
        $w("#buttonCreateWebsite").link = "https://users.wix.com/signin?utm_campaign=bd_blog_mobile&experiment_id=main_all_cta&_gl=1*ng59dh*_ga*MTA0MTE5OTAwOS4xNjE0NTQxMjEx*_ga_H314XQHSPY*MTYxNDY3NjgyNi4xLjAuMTYxNDY3NjgyNi4w&loginDialogContext=signup&forceRender=true"
    } else {
        $w("#buttonCreateWebsite").link = "https://users.wix.com/signin?loginDialogContext=signup&utm_campaign=bd_blog&experiment_id=main_all_cta"
    }
});